<template>
  <v-toolbar dark absolute color="primary">
    <v-toolbar-side-icon @click.stop="toggleAppDrawer"></v-toolbar-side-icon>

    <v-toolbar-title v-show="$vuetify.breakpoint.smAndUp">{{
      appTitle
    }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <template v-for="(tool, name) in tools">
        <v-btn
          @click="toggleContent(tool, name)"
          v-if="tool.showInTopToolbar"
          :key="name"
          small
          class="ml-2 mr-2"
          icon
        >
          <v-icon>{{ tool.icon }}</v-icon>
        </v-btn>
      </template>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "TheTopToolbar",
  methods: {
    ...mapActions(["setShowAppDrawer", "activateTool"]),
    toggleAppDrawer: function() {
      this.setShowAppDrawer(!this.showAppDrawer);
    },
    toggleContent: function(tool, name) {
      this.showAppDrawer = false;
      if (tool.useSidebarOnMobile) {
        this.$eventHub.$emit("toggle-tool", name);
      } else {
        this.activateTool(name);
      }
    }
  },
  computed: {
    ...mapState(["appTitle", "tools"])
  }
};
</script>

<style></style>
